export const ORGANIZER_STATUS = {
  active: 'active',
  inactive: 'inactive',
  deactivated: 'deactivated',
  rejected: 'rejected',
  pendingApproval: 'pending_approval',
};
